import React, { useContext } from 'react';
import LeftSubMenu from "./left.menu.parent.component";
import MyContext from '../../context/MyContext';

export const LeftMenu = (props) => {

    const { setLeftToggle } = useContext(MyContext)

    function toggleEditor() {

        if (document.getElementsByClassName('tdStyle1')[0].offsetWidth === 70) {

            setLeftToggle('block')
            document.getElementsByClassName('tdStyle1')[0].style.width = "426px";
            document.getElementsByClassName('editorCloser2')[0].style.display = "none";
            document.getElementsByClassName('editorCloser')[0].style.display = "block";
            document.getElementsByClassName('tdStyle2')[0].style.width = "calc(100% - " + (625) + "px)";

        } else if (document.getElementsByClassName('tdStyle1')[0].offsetWidth === 426) {

            setLeftToggle('none')
            document.getElementsByClassName('tdStyle1')[0].style.width = "70px";
            document.getElementsByClassName('tdStyle2')[0].style.width = "calc(100% - " + (625 - 356) + "px)";
            document.getElementsByClassName('editorCloser2')[0].style.display = "block";
            document.getElementsByClassName('editorCloser')[0].style.display = "none";
        }
    }

    return (<div className="tdStyle1">

        <div className="editorCloser2" style={{ display: "none" }} onClick={toggleEditor}>
            <svg className="iconCloser" viewBox="0 0 7 12" style={{ width: '5px', top: '17px' }} className="svg-sprite-colorable"><title>arrow_left_drawer</title>
                <path d="M 6.74 5.31C 6.74 5.31 2.09 0.29 2.09 0.29 1.92 0.1 1.7 0 1.45 0 1.19 0 0.98 0.1 0.81 0.29 0.81 0.29 0.26 0.87 0.26 0.87 0.09 1.06-0 1.29-0 1.56-0 1.83 0.09 2.06 0.26 2.26 0.26 2.26 3.73 6 3.73 6 3.73 6 0.26 9.74 0.26 9.74 0.09 9.93-0 10.16-0 10.44-0 10.7 0.09 10.94 0.26 11.14 0.26 11.14 0.81 11.71 0.81 11.71 0.98 11.9 1.2 12 1.45 12 1.7 12 1.91 11.9 2.09 11.71 2.09 11.71 6.74 6.7 6.74 6.7 6.91 6.5 7 6.27 7 6 7 5.73 6.91 5.5 6.74 5.31Z" fill="#414E60"></path>       </svg>
        </div>

        <div className="editorCloser" style={{ display: "block" }} onClick={toggleEditor}>
            <svg className="iconCloser" viewBox="0 0 7 12" style={{ width: '5px', top: '17px' }} className="svg-sprite-colorable"><title>arrow_left_drawer</title><path d="M 0.26 5.31C 0.26 5.31 4.91 0.29 4.91 0.29 5.08 0.1 5.3 0 5.55 0 5.81 0 6.02 0.1 6.19 0.29 6.19 0.29 6.74 0.87 6.74 0.87 6.91 1.06 7 1.29 7 1.56 7 1.83 6.91 2.06 6.74 2.26 6.74 2.26 3.27 6 3.27 6 3.27 6 6.74 9.74 6.74 9.74 6.91 9.93 7 10.16 7 10.44 7 10.7 6.91 10.94 6.74 11.14 6.74 11.14 6.19 11.71 6.19 11.71 6.02 11.9 5.8 12 5.55 12 5.3 12 5.09 11.9 4.91 11.71 4.91 11.71 0.26 6.7 0.26 6.7 0.09 6.5-0 6.27-0 6-0 5.73 0.09 5.5 0.26 5.31Z" fill="#414E60"></path></svg>
        </div>

        <div className="centeralWrapper"><div className="centerTopContent"><div className="leftManuWrapper">
            <LeftSubMenu AIContentPopup={props.AIContentPopup}
                  setAIContentPopup={props.setAIContentPopup} setTextContext={props.setTextContext} setchrPop={props.setchrPop} setChrPopData={props.setChrPopData} />
        </div></div></div>
    </div>
    );
};
export default LeftMenu;